import { isDev } from '@/../../common/src/utils/util';
import CryptoJS from 'crypto-js';

const AES_KEY = 'd4day4rs7uem2pia'; // 密钥, AES-128 需16个字符, AES-256 需要32个字符
const AES_IV = 'na2uvf9eb0ctcnh8'; // 密钥偏移量，16个字符
const key = CryptoJS.enc.Utf8.parse(AES_KEY);
const iv = CryptoJS.enc.Utf8.parse(AES_IV);

export const encrypt = (plaintext: string) => {
  // var plaintext = "Jt23456!!!"; //88092611
  const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

export const decrypt = (encryptText: string) => {
  const decrypted = CryptoJS.AES.decrypt(encryptText, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

if (isDev()) {
  window.decrypt = decrypt;
  window.encrypt = encrypt;
}
